// Function to check and update the bottom style
function checkAndUpdateBottomStyle() {
  // Update the site padding on body if attrac loads.

  const siteControlHeight =
    document.querySelector("#site-control").offsetHeight;
  document.documentElement.style.setProperty(
    "--nav-height",
    siteControlHeight + "px"
  );

  const cookieConsentDiv = document.querySelector(".cc-window");
  const targetDiv = document.querySelector("#usntA40Toggle");
  // target Div for Chat
  const targetDivChat = document.querySelector("#reamaze-widget");





  // Check if the div is not hidden (display is not 'none')
  if (
    cookieConsentDiv &&
    getComputedStyle(cookieConsentDiv).display !== "none"
  ) {
    // Calculate the height of the cc-window + 10px
    const windowHeight = cookieConsentDiv.offsetHeight + 65;
    const windowHeightChat = cookieConsentDiv.offsetHeight + 10;

    // Set the bottom style to height of cc-window + 10px
    if (targetDiv && targetDiv.style) {
      targetDiv.style.setProperty("bottom", `${windowHeight}px`, "important");
    }
    if (targetDivChat && targetDivChat.style) {
      targetDivChat.style.setProperty("bottom", `${windowHeightChat}px`, "important");
    }
  } else {
    // Only remove the 'bottom' style if it exists
    if (targetDiv && targetDiv.style.bottom) {
      targetDiv.style.removeProperty("bottom");
    }
    if (targetDivChat && targetDivChat.style.bottom) {
      targetDivChat.style.removeProperty("bottom");
    }
  }
}

// Initial check on page load
document.addEventListener("DOMContentLoaded", () => {
  // Immediately call the function when the page is loaded
  checkAndUpdateBottomStyle();

  // Set up a MutationObserver to watch for any DOM changes
  const observer = new MutationObserver(() => {
    checkAndUpdateBottomStyle(); // Re-run the function on any DOM change
  });

  // Target the entire document for changes (subtree includes all child nodes)
  const config = {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
  };
  observer.observe(document.body, config);

  // Optional: You can also listen for clicks on the document to trigger the check manually
  document.addEventListener("click", checkAndUpdateBottomStyle);
});

// --------------------------------------
// CODE FOR READ MORE AND LESS
//-----------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  const content = document.getElementById("unsubMoreLessContent");
  const button = document.getElementById("unsubMoreLessButton");

  if (content && button) {
    button.addEventListener("click", () => {
      if (content.classList.contains("unsub-more-less-show")) {
        content.classList.remove("unsub-more-less-show");
        button.textContent = "read less";
      } else {
        content.classList.add("unsub-more-less-show");
        button.textContent = "read less";
      }
    });
  }
});

// ============================================
// Custom Events to load swatch preview.
// =======================================
document.addEventListener("DOMContentLoaded", () => {
  // Function to attach event listeners
  const attachEventListeners = () => {
    document.querySelectorAll(".click-swatch-preview").forEach((element) => {
      element.removeEventListener("click", handleClick); // Ensure no duplicate events
      element.addEventListener("click", handleClick);
    });

    document.querySelectorAll(".product-block").forEach((element) => {
      if (!element.classList.contains("not-primary-product-block")) {
        element.addEventListener("mouseenter", handleMouseOutSwatch);
      }
    });
  };

  const handleMouseOutSwatch = (event) => {
    const temporaryBlockImages = document.querySelectorAll(
      ".image--hover-second-temporary-block"
    );
    temporaryBlockImages.forEach((imageElement) => {
      imageElement.classList.remove("image--hover-second-temporary-block");
      imageElement.classList.add("image--hover-second");
    });
  };
  const handleMouseInSwatch = (event) => {
    const temporaryBlockImages = document.querySelectorAll(
      ".image--hover-second"
    );
    temporaryBlockImages.forEach((imageElement) => {
      imageElement.classList.add("image--hover-second-temporary-block");
      imageElement.classList.remove("image--hover-second");
    });
  };

  // Handle click event
  const handleClick = (event) => {


    const element = event.currentTarget;
    const mainValue = element.getAttribute("data-main");
    const subValue = element.getAttribute("data-sub");

    if (mainValue && subValue) {
      // Add "hidden" to all elements with class main_<mainValue>
      document.querySelectorAll(`.main_${mainValue}`).forEach((mainElement) => {
        mainElement.classList.add("hidden");
      });

      // Remove "hidden" from all elements with both classes main_<mainValue> and child_<subValue>
      document
        .querySelectorAll(`.main_${mainValue}.child_${subValue}`)
        .forEach((childElement) => {
          childElement.classList.remove("hidden");
        });

      document
        .querySelectorAll(`.main_${mainValue}.child_${subValue}`)
        .forEach((childElement) => {
          // Update elements with class image image--hover-second
          const hoverSecondImages = childElement.querySelectorAll(
            ".image.image--hover-second"
          );
          hoverSecondImages.forEach((imageElement) => {
            imageElement.classList.remove("image--hover-second");
            imageElement.classList.add("image--hover-second-temporary-block");
          });
        });
    }
  };

  // Attach the event listeners for the first time
  attachEventListeners();

  // Observe changes to the DOM and reattach event listeners
  const observer = new MutationObserver(() => {
    attachEventListeners();
  });

  // Start observing the body for child element additions/removals
  observer.observe(document.body, { childList: true, subtree: true });
});

// ============================================
// Ends Custom Events to load swatch preview.
// =======================================

// =========================================
// load more for to show additonal swatches
// =========================================
document.addEventListener("DOMContentLoaded", () => {
  // Function to add event listeners
  const addEventListeners = () => {
    document.querySelectorAll(".additional-color").forEach((element) => {
      element.removeEventListener("click", handleClick); // Remove any existing listener
      element.addEventListener("click", handleClick); // Add the click event listener
    });
  };

  // Click event handler
  const handleClick = function () {
    const mainProductId = this.getAttribute("data-parent");

    // Reveal elements with the matching data-main attribute
    const elementsToReveal = document.querySelectorAll(
      `[data-main="${mainProductId}"]`
    );
    elementsToReveal.forEach((el) => el.classList.remove("hidden"));

    // Hide all elements with the matching data-parent attribute
    const elementsToHide = document.querySelectorAll(
      `[data-parent="${mainProductId}"]`
    );
    elementsToHide.forEach((el) => el.classList.add("hidden"));
  };

  // Initial setup
  addEventListeners();

  // Watch for DOM changes
  const observer = new MutationObserver(() => {
    addEventListeners(); // Re-apply listeners on DOM changes
  });

  observer.observe(document.body, {
    childList: true, // Observe direct child additions/removals
    subtree: true, // Observe changes in all descendants
  });
});

// =========================================
// ends -- load more for to show additonal swatches
// =========================================

// =======================================================
// The code to display the count on the Gift Recipeint Message.
// =============================================================
document.addEventListener("DOMContentLoaded", function () {
  // Get references to the textarea and character count elements
  const textarea = document.getElementById("gift-card-recipient-message");
  const charCount = document.getElementById("char-count");

  // Check if both elements are available before proceeding
  if (textarea && charCount) {
    const maxChars = textarea.getAttribute("maxlength");

    // Function to update the character count
    function updateCharCount() {
      const currentLength = textarea.value.length;
      charCount.textContent = `${currentLength}/${maxChars}`;
    }

    // Event listener to track input in the textarea
    textarea.addEventListener("input", updateCharCount);

    // Initialize character count on page load
    updateCharCount();
  }
});
// =======================================================
// Ends. The code to display the count on the Gift Recipeint Message.
// =============================================================

// ==========================================================================
// custom validation for the gift page.
// ============================================================================

class CustomFormValidator {
  constructor(formId) {
    this.form = document.getElementById(formId);

    if (!this.form) {
      console.error(`Form with id "${formId}" not found.`);
      return;
    }

    // Add novalidate to disable native HTML validation
    this.form.setAttribute("novalidate", "true");

    this.fields = this.form.querySelectorAll("input, textarea, select");
    this.attachEventListeners();
    this.injectErrorContainers();
  }

  injectErrorContainers() {
    // Automatically add error containers after each field
    this.fields.forEach((field) => {
      // Skip hidden fields
      if (this.isHidden(field)) return;

      const errorContainerId = `${field.id || field.name}-un-error`; // Change -error to -un-error
      let errorContainer = document.getElementById(errorContainerId);

      // Create error container if it does not exist
      if (!errorContainer) {
        errorContainer = document.createElement("div");
        errorContainer.id = errorContainerId;
        errorContainer.className = "un-error-message"; // Use "un-error-message" class
        errorContainer.style.display = "none"; // Initially hidden
        field.insertAdjacentElement("afterend", errorContainer);
      }
    });
  }

  isHidden(field) {
    return (
      field.offsetParent === null ||
      window.getComputedStyle(field).display === "none"
    );
  }

  attachEventListeners() {
    // Add listeners for real-time validation
    this.fields.forEach((field) => {
      //  field.addEventListener("input", () => this.validateField(field));
    });

    // Add a listener for form submission
    this.form.addEventListener("submit", (event) => {
      event.preventDefault(); // Prevent default form submission
      event.stopPropagation();

      const isValid = this.validateForm();
      if (isValid) {
        console.log("Form is valid. Proceeding with submission...");
        //  this.form.submit(); // Submit the form programmatically
      }
    });
  }

  validateForm() {
    let isFormValid = true;
    let firstInvalidField = null;

    this.fields.forEach((field) => {
      if (this.isHidden(field)) return; // Skip hidden fields

      const isValid = this.validateField(field);
      if (!isValid && !firstInvalidField) {
        firstInvalidField = field;
      }
      isFormValid = isFormValid && isValid;
    });

    if (firstInvalidField) {
      firstInvalidField.scrollIntoView({ behavior: "smooth", block: "center" });
      firstInvalidField.focus();
    }

    return isFormValid;
  }

  validateField(field) {
    const errorContainerId = `${field.id || field.name}-un-error`; // Change -error to -un-error
    let errorContainer = document.getElementById(errorContainerId);

    // Ensure the error container exists
    if (!errorContainer) {
      errorContainer = document.createElement("div");
      errorContainer.id = errorContainerId;
      errorContainer.className = "un-error-message"; // Use "un-error-message" class
      errorContainer.style.display = "none"; // Initially hidden
      field.insertAdjacentElement("afterend", errorContainer);
    }

    // Reset error message and hide the error container
    errorContainer.textContent = "";
    errorContainer.style.display = "none"; // Hide by default

    // Perform validation checks
    if (field.validity.valueMissing) {
      errorContainer.textContent = "please fill out this field.";
      errorContainer.style.display = "block"; // Show error message if there is an error
      return false;
    }

    if (field.type === "email" && field.validity.typeMismatch) {
      errorContainer.textContent = "Please enter a valid email address.";
      errorContainer.style.display = "block"; // Show error message if there is an error
      return false;
    }

    if (field.type === "number" && field.validity.rangeOverflow) {
      errorContainer.textContent = `Value must be less than or equal to ${field.max}.`;
      errorContainer.style.display = "block"; // Show error message if there is an error
      return false;
    }

    if (field.type === "number" && field.validity.rangeUnderflow) {
      errorContainer.textContent = `Value must be greater than or equal to ${field.min}.`;
      errorContainer.style.display = "block"; // Show error message if there is an error
      return false;
    }

    if (
      field.hasAttribute("minlength") &&
      field.value.length < field.getAttribute("minlength")
    ) {
      errorContainer.textContent = `Please enter at least ${field.getAttribute(
        "minlength"
      )} characters.`;
      errorContainer.style.display = "block"; // Show error message if there is an error
      return false;
    }

    if (
      field.hasAttribute("maxlength") &&
      field.value.length > field.getAttribute("maxlength")
    ) {
      errorContainer.textContent = `Please enter no more than ${field.getAttribute(
        "maxlength"
      )} characters.`;
      errorContainer.style.display = "block"; // Show error message if there is an error
      return false;
    }

    return true;
  }
}

// Initialize the validation for the form
document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById(
    "product-form-template--18240530710680__main-8470515286168"
  );

  if (form) {
    new CustomFormValidator(
      "product-form-template--18240530710680__main-8470515286168"
    );
  }
});

// ==========================================================================
// ends - custom validation for the gift page.
// ============================================================================

// ==========================================================================
// Disabling dates after three months and in the past
// ============================================================================

function setDateRange(inputId) {
  // Get today's date in the format YYYY-MM-DD
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const minDate = `${yyyy}-${mm}-${dd}`;

  // Calculate the date 90 days from today
  const maxDateObject = new Date();
  maxDateObject.setDate(today.getDate() + 90);
  const yyyyMax = maxDateObject.getFullYear();
  const mmMax = String(maxDateObject.getMonth() + 1).padStart(2, "0");
  const ddMax = String(maxDateObject.getDate()).padStart(2, "0");
  const maxDate = `${yyyyMax}-${mmMax}-${ddMax}`;

  // Find the input element and set min and max attributes
  const dateInput = document.getElementById(inputId);
  if (dateInput) {
    dateInput.min = minDate;
    dateInput.max = maxDate;
  }
}

// Apply on page load
document.addEventListener("DOMContentLoaded", () => {
  setDateRange("gift-card-recipient-send-on");
});

// Observe DOM changes for dynamically added elements
const observer = new MutationObserver(() => {
  setDateRange("gift-card-recipient-send-on");
});

observer.observe(document.body, { childList: true, subtree: true });

// ==========================================================================
// ends - Disabling dates after three months and in the past
// ============================================================================

// ==========================================================================
// When scroll stops adjust height
// ============================================================================

let scrollTimeout;

function updateNavHeight() {
  const siteControlHeight =
    document.querySelector("#site-control").offsetHeight;
  document.documentElement.style.setProperty(
    "--nav-height",
    siteControlHeight + "px"
  );
}

// Call the function immediately when the page loads
updateNavHeight();

// Add a scroll event listener
window.addEventListener("scroll", () => {
  // Clear any existing timeout
  clearTimeout(scrollTimeout);

  // Set a timeout to call the function after scrolling stops
  scrollTimeout = setTimeout(() => {
    updateNavHeight();
  }, 400); // Adjust the delay (200ms) as needed for your application
});

// ==========================================================================
// ends - When scroll stops adjust height
// ============================================================================

// ==========================================================================
// Gift Card : Activating the checkbox when the user comes back on the page.
// ============================================================================

// Call synchronizeProperties on window load
window.onload = () => {
  // Query all instances of the custom element
  const giftCardElements = document.querySelectorAll("gift-card-recipient");
  giftCardElements.forEach((element) => {
    // Ensure the method exists and is callable
    if (typeof element.synchronizeProperties === "function") {
      element.synchronizeProperties();
    }
  });
};

// ==========================================================================
// Gift Card Ends: Activating the checkbox when the user comes back on the page.
// ============================================================================

// ==========================================================================
// Size Chart : Function to buid tabs on the Products Page.
// ============================================================================

function convertToTabs(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  // Create tab navigation
  const tabs = document.createElement("div");
  tabs.classList.add("unsub-tabs");

  // Get all tab sections
  const sections = container.children;
  const contentWrapper = document.createElement("div");

  Array.from(sections).forEach((section, index) => {
    const tabName = section.dataset.caption || `Tab ${index + 1}`; // Use data-caption or default name
    const sectionClass = `unsub-${section.classList[0]}`; // Unique prefixed class
    section.classList.add(sectionClass);

    const tabButton = document.createElement("div");
    tabButton.classList.add("unsub-tab");
    tabButton.textContent = tabName;
    tabButton.dataset.target = sectionClass;

    // Show first tab by default
    if (index === 0) {
      tabButton.classList.add("unsub-active");
      section.classList.add("unsub-active");
    }

    tabButton.addEventListener("click", function () {
      document
        .querySelectorAll(".unsub-tab")
        .forEach((tab) => tab.classList.remove("unsub-active"));
      document
        .querySelectorAll(".unsub-tab-content")
        .forEach((content) => (content.style.display = "none"));

      this.classList.add("unsub-active");
      document.querySelector(`.${this.dataset.target}`).style.display = "block";
    });

    tabs.appendChild(tabButton);
    section.classList.add("unsub-tab-content");
    section.style.display = index === 0 ? "block" : "none";
    contentWrapper.appendChild(section);
  });

  // Insert the new structure
  container.innerHTML = "";
  container.appendChild(tabs);
  container.appendChild(contentWrapper);
}

// Run function on page load
document.addEventListener("DOMContentLoaded", function () {
  convertToTabs("size_chart");
});

// ==========================================================================
// Ends - Size Chart : Function to buid tabs on the Products Page.
// ============================================================================

// ==========================================================================
// Size Chart :  Transpose table on Mobile.
// ============================================================================

function isMobile() {
  return window.innerWidth <= 768; // Adjust breakpoint if needed
}

function transposeTables() {
  const tables = document.querySelectorAll("#size_chart table");
  if (!tables.length) return;

  tables.forEach((table) => {
    const rows = Array.from(table.rows);
    const rowCount = rows.length;
    const colCount = rows[0].cells.length;

    // Only transpose if columns are more than rows
    if (colCount <= rowCount) return;

    const transposedData = [];
    const headerIndexes = new Set();

    // Create an array to store transposed data, preserving <th>
    for (let col = 0; col < colCount; col++) {
      transposedData[col] = [];
      for (let row = 0; row < rowCount; row++) {
        const cell = rows[row].cells[col];
        transposedData[col][row] = {
          content: cell.innerHTML,
          isHeader: cell.tagName.toLowerCase() === "th",
        };
        if (cell.tagName.toLowerCase() === "th") {
          headerIndexes.add(col);
        }
      }
    }

    // Create new transposed table
    const newTable = document.createElement("table");
    newTable.className = table.className;

    transposedData.forEach((rowData, rowIndex) => {
      const row = newTable.insertRow();
      rowData.forEach((cellData, colIndex) => {
        const cell = headerIndexes.has(rowIndex)
          ? document.createElement("th")
          : row.insertCell();
        cell.innerHTML = cellData.content;
        row.appendChild(cell);
      });
    });

    // Replace the old table with the new transposed one
    table.parentNode.replaceChild(newTable, table);
  });
}

// Run the function on page load if mobile
if (isMobile()) {
  transposeTables();
}

// Optional: Recheck on window resize
window.addEventListener("resize", () => {
  if (isMobile()) {
    transposeTables();
  }
});

// ==========================================================================
// End : Size Chart :  Transpose table on Mobile.
// ============================================================================

// ==========================================================================
// GA4 Banner Tracking for Top Banner
// ==========================================================================

document.addEventListener("DOMContentLoaded", function () {
  const banner = document.getElementById("aph_bar_wrapper_460599");

  if (!banner) return;

  // Track visibility using IntersectionObserver
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // console.log("Banner is visible to the user");

          Shopify.analytics.publish("view_promotion", {
            event: "view_promotion",
            promotion_id: "PROMO1",
            promotion_name: "Attrac",
          });

          observer.unobserve(banner); // Track only once
        }
      });
    },
    { threshold: 0.5 }
  );

  observer.observe(banner);

  // Track clicks only on the clickable banner sections
  banner.addEventListener("click", function (event) {
    const clickableBar = event.target.closest(".aph_bar_clickable");

    if (clickableBar) {
      const targetInput = clickableBar.querySelector(".aph_clickableBarTarget");
      if (targetInput && targetInput.value) {
        const destinationUrl = targetInput.value;
     //   console.log("Banner link clicked:", destinationUrl);

        Shopify.analytics.publish("select_promotion", {
          event: "select_promotion",
          promotion_id: "PROMO1",
          promotion_name: "Attrac",
          destination_url: destinationUrl, // Capture the link user is navigating to
        });
      }
    }
  });
});

// ==========================================================================
// GA4 Banner Tracking for Top Banner
// ==========================================================================

// ==============================================================================
// QUICK - ADD TO CART (phs version with size select -> add -> revert)
// ==============================================================================


function updateMiniCartMessage() {
  // 1. Get the message from our global settings object
  const newMsg = window.themeSettings?.cartConfig?.minicartMessage;
  
  // 2. Select the target element
  const messageContainer = document.querySelector('.unsub-mini-cart-long-msg');

  // 3. Update the content if both exist
  if (messageContainer && newMsg) {
    messageContainer.textContent = newMsg;
    
    // Optional: If you want to support HTML/bolding from the textarea:
    // messageContainer.innerHTML = newMsg;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  let selectedVariantId = null;

  document.body.addEventListener("click", function (e) {
 
    const sizeButton = e.target.closest(".phs-size-button");
    if (sizeButton) {
   
      e.preventDefault();
      const overlay = sizeButton.closest(".phs-overlay");
      const sizeButtons = overlay.querySelectorAll(".phs-size-button");
      const actionRow = overlay.querySelector(".phs-action-row");

      selectedVariantId = sizeButton.dataset.variantId;
      const isAvailable = sizeButton.dataset.available === "true";

      sizeButtons.forEach((btn) => btn.classList.remove("selected"));
      sizeButton.classList.add("selected");

    

      if (isAvailable) {
        actionRow.innerHTML = `<button class="phs-add-to-cart-btn" data-variant-id="${selectedVariantId}">add to cart</button>`;
      } else {
        actionRow.innerHTML = `<button class="phs-out-of-stock-btn" disabled>out of stock</button>`;
      }

      return;
    }

    const addToCartBtn = e.target.closest(".phs-add-to-cart-btn");
    if (addToCartBtn) {
      e.preventDefault();

      // Skip if data-variant-id is already present — button already handled
      if (addToCartBtn.hasAttribute("data-variant-id")) {
        return;
      }

      const overlay = addToCartBtn.closest(".phs-overlay");
      const sizeButtons = overlay.querySelectorAll(".phs-size-button");
      const actionRow = overlay.querySelector(".phs-action-row");

      if (!selectedVariantId) {
        alert("Please select a size.");
        return;
      }

      addToCartBtn.textContent = "Adding...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: selectedVariantId, quantity: 1 }),
      })
        .then((res) => res.json())
        .then((product) => {
          window.lastAddedVariantId = selectedVariantId;
          openCustomDrawer(() => {
            selectedVariantId = null;
            sizeButtons.forEach((btn) => btn.classList.remove("selected"));
            actionRow.innerHTML = `<div class="phs-action-text">select a size.</div>`;
          });
        })
        .catch((err) => {
          console.error("Add to cart failed", err);
          actionRow.innerHTML = `<div class="phs-action-text">select a size.</div>`;
        });
    }
  });
});

// Overlay helpers
function showItemOverlay(container, text = "Loading...") {
  if (!container.querySelector(".cart-item-overlay")) {
    const overlay = document.createElement("div");
    overlay.className = "cart-item-overlay";
    overlay.style.cssText = `
      position: absolute;
      inset: 0;
      background-color: rgba(255, 255, 255, 0.75);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
      font-weight: 600;
      font-size: 14px;
      font-family: sans-serif;
    `;
    overlay.innerHTML = `
  <div style="display: flex; align-items: center; justify-content: center; height: 100%;">
    <svg class="unsub_loader" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <style>
        .unsub_loader {
          animation: rotate 1s linear infinite;
        }
        @keyframes rotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
      <path d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM3.5402 12C3.5402 16.6722 7.32778 20.4598 12 20.4598C16.6722 20.4598 20.4598 16.6722 20.4598 12C20.4598 7.32778 16.6722 3.5402 12 3.5402C7.32778 3.5402 3.5402 7.32778 3.5402 12Z" fill="#111111" fill-opacity="0.4"/>
      <path d="M12 22.23C12 23.2075 12.7967 24.0134 13.7636 23.8697C16.2938 23.4938 18.6548 22.3158 20.4853 20.4853C22.3158 18.6548 23.4938 16.2938 23.8697 13.7636C24.0134 12.7967 23.2075 12 22.23 12C21.2525 12 20.4786 12.801 20.2755 13.7572C19.9382 15.3455 19.1479 16.8164 17.9821 17.9821C16.8164 19.1479 15.3455 19.9382 13.7572 20.2755C12.801 20.4786 12 21.2525 12 22.23Z" fill="#111111"/>
    </svg>
  </div>
`;

    container.appendChild(overlay);
  }
}

function removeItemOverlay(container) {
  const overlay = container.querySelector(".cart-item-overlay");
  if (overlay) overlay.remove();
}

window.applyDiscountAndAddProduct = async function(buttonElement, code, variantId, quantity = 1) {
  const originalText = buttonElement.innerText;
  const discountCode = String(code).toUpperCase();

  // Initial UI update
  console.log(`[DEBUG] Starting process for code: ${discountCode}`);
  buttonElement.innerText = "Adding item...";
  buttonElement.disabled = true;
  buttonElement.backgroundColor = "unset";

  const productVariantId = Number(variantId);
  const productQuantity = Number(quantity);

  const productData = {
    items: [{ id: productVariantId, quantity: productQuantity }],
    discount: discountCode
  };

  try {
    // --- STEP 1: Add product to cart ---
    console.log(`[DEBUG] 1/2: Adding variant ${productVariantId} to cart.`);
    let response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(productData)
    });

    if (!response.ok) throw new Error('Failed to add product.');

    // --- STEP 2: Apply discount code ---
    buttonElement.innerText = "Applying code...";
    console.log(`[DEBUG] 2/2: Applying discount code ${discountCode}.`);

    response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: discountCode })
    });

    if (!response.ok) throw new Error('Failed to apply discount in cart.');

    // --- STEP 3: Fetch final cart ---
    console.log('[DEBUG] Discount applied, fetching final cart data.');
    const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await cartResponse.json();

    // --- STEP 4: Check if the specific line item is free ---
    const addedItem = cart.items.find(item => item.variant_id === productVariantId);
    let lineItemIsFree = false;

    if (addedItem) {
      console.log(`[DEBUG] Item found. Final line price (in cents): ${addedItem.final_line_price}`);
      if (addedItem.final_line_price === 0) {
        lineItemIsFree = true;
      }
    }

    // --- STEP 5: Update UI ---
    if (lineItemIsFree) {
      console.log('[DEBUG] SUCCESS: Item is free. Coupon confirmed.');

      
      buttonElement.innerText = `${discountCode} applied!`;
      buttonElement.disabled = true;
      buttonElement.backgroundColor = "unset";


// Update all .gift-offer-container instances
const giftContainers = document.querySelectorAll('.gift-offer-container');

if (giftContainers.length > 0) {
    giftContainers.forEach((giftContainer) => {
        giftContainer.outerHTML = `
            <div class="gift-code-applied">
                <div class="tick-icon">
                    <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path></svg>
                </div>
                gift added to cart
            </div>
        `;
    });
}



       document.dispatchEvent(
                  new CustomEvent("theme:cartchanged", {
                    bubbles: true,
                    cancelable: false,
                  })
                );


    } else {
  console.log('[DEBUG] FAILURE: Item price is NOT $0.00. Coupon failed/not applicable.');

  // --- REMOVE the item that was added earlier ---
  try {
      console.log(`[DEBUG] Removing variant ${productVariantId} because coupon invalid.`);

      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: addedItem.key,  // precise Shopify line item identifier
          quantity: 0         // remove line item
        })
      });

      console.log('[DEBUG] Item removed successfully.');

      // Fire cart change event
      document.dispatchEvent(
        new CustomEvent("theme:cartchanged", {
          bubbles: true,
          cancelable: false,
        })
      );

  } catch (removeErr) {
      console.error("[DEBUG] ERROR removing invalid free gift:", removeErr);
  }

  // --- Update UI ---
  buttonElement.innerText = "Code Not Eligible 🗙";
  // buttonElement.style.backgroundColor = 'red';
  buttonElement.disabled = false;
  buttonElement.backgroundColor = "unset";
}

  } catch (error) {
    console.error('[DEBUG] FATAL ERROR during process:', error);
    buttonElement.innerText = originalText;
    buttonElement.disabled = false;
      buttonElement.backgroundColor = "unset";
    alert(`Could not complete the action. Error: ${error.message}`);
  }
};

// Cart drawer logic
function openCustomDrawer(
  onReady = null,
  interfaceType = "small_notification"
) {

  updateMiniCartMessage();
  interfaceType = window.themeSettings.cartConfig.interfaceType;

if (window.themeSettings.cartConfig.interfaceType === 'long_notification') {
  const siteControl = document.querySelector('.site-control');
  
  if (siteControl) {
    siteControl.style.zIndex = "20";
    // Optional: Add a class for more complex styling
    siteControl.classList.add('is-long-cart');
  }
}


  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const totalQty = cart.items.reduce((sum, item) => sum + item.quantity, 0);

      // Update global counters
      const counterElement = document.getElementById("unsub-cart-count");
      if (counterElement) counterElement.innerHTML = `${totalQty}`;

      const bagCounter = document.querySelector(".unsub-bag-counter");
      if (bagCounter) bagCounter.textContent = `your bag (${totalQty})`;

      // ✅ NAV height offset
    
       const siteControl = document.getElementById('site-control');
            
            // Initialize the default offset value
            let offset = 25;
            
            // Check if the element was found
            if (siteControl) {
                // If found, use its height (offsetHeight includes padding and borders)
                offset = siteControl.offsetHeight;
            }

      // ✅ SMALL NOTIFICATION INTERFACE
      if (interfaceType === "small_notification") {
    //    console.log("Small notification branch hit 123");
        const product = cart.items.find(
          (item) => item.variant_id == window.lastAddedVariantId
        );
        //  console.log("Small notification branch hit 123f");
        if (!product) return;
       //   console.log("Small notification branch hit 12ddddd3");

        const thumbUrl = product.image || "";
        const imgAlt = product.title || "";
        const variantHtml = product.variant_title
          ? `<p class="cart-product__variant cart-product__content__meta">${product.variant_title}</p>`
          : "";
        const productPrice = product.price
          ? `$${(product.price / 100).toFixed(2)}`
          : "";
        const noCheckoutButton = false;

        // Show small modal (same structure as in your sample)
// Show small modal (same structure as in your sample)
// Show small modal
fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    let giftCardHtml = '';


    if (window.giftSettings && window.giftSettings.enable_gift) {
      
      const { threshold, variant_id, discount_code, image,gift_description, gift_details_page_link } = window.giftSettings;

      const cartTotal = cart.total_price / 100; // convert cents to dollars
      const remaining = Math.max(threshold - cartTotal, 0);
      const qualified = cartTotal >= threshold;

      // Check if gift variant is already in cart
      const giftInCart = cart.items.some(item => item.variant_id == variant_id);

      const progressPercent = Math.min((cartTotal / threshold) * 100, 100);

      // If qualified and gift is already in cart, show only discount message
      if (qualified && giftInCart) {
        giftCardHtml = `<div class="gift-code-applied">
        <div class="tick-icon">
        <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.799805 3.00156L2.7998 5.00156L7.1998 0.601562" stroke="white" stroke-width="1.5"/>
        </svg>
        </div>
        
        ${discount_code} applied!</div>`;
         giftCardHtml = "";
      } else {
        // Original layout for all other cases
        giftCardHtml = `
          <div class="gift-offer-container">
            <div class="gift-header">
              ${
                qualified
                  ? 'you qualify for an exclusive free tote!'
                  : `you’re <span class="bold-amount"> $${remaining.toFixed(0)} </span> away from qualifying for an
exclusive free tote!`
              }
            </div>
          
            <div class="gift-amounts">
            
              <div class="gift-progress">
                 <div class="gift-progress-fill ${qualified ? 'reached' : ''}" style="width:${progressPercent}%;"></div>
              </div>
             
            </div>

            <div class="gift-body">
              <img src="${image}" alt="Complimentary gift" class="gift-image">
              <div class="gift-text">
                ${gift_description} 
                ${
                  qualified
                    ? `<button class="gift-button" type="button" onclick="window.applyDiscountAndAddProduct(this, '${discount_code}', ${variant_id}, 1)">
                    add gift to cart  </button>`
                    : `<a href="${gift_details_page_link}" class="gift-link">details</a>`
                }
              </div>
            </div>
          </div>
        `;
      }
    }

  




    

    showThemeModal(
      [
        '<div id="added-to-cart" class="theme-modal theme-modal--small sam" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">',
        `<div class="inner" style="top:${offset}px">`,
        '<a href="#" data-modal-close class="modal-close">&times;</a>',
        `<h4 id="added-to-cart-title">${theme.icons.tick}${theme.strings.productAddedToCart}</h4>`,
        '<div class="cart-product">',
        `<div class="cart-product__image"><img src="${thumbUrl}" alt="${imgAlt}"/></div>`,
        '<div class="cart-product__content">',
        `<p class="cart-product__content__title ">${product.product_title}</p>`,
        `<p class="cart-product__price cart-product__content__meta">${productPrice}</p>`,
        `${variantHtml}`,
        "</div>",
        "</div>",

        `<p class="links ${noCheckoutButton ? "links--no-checkout" : ""}">`,
        `<a href="${theme.routes.cart_url}" class="button ${noCheckoutButton ? "" : "alt"}">${theme.strings.viewCart}</a>`,
        `<a href="${theme.routes.checkout}" class="button button--checkout">${theme.strings.popupCheckout}</a>`,
        "</p>",
        giftCardHtml, // 👈 Inserted Gift Card Offer Block
        "</div>",
        "</div>",
      ].join(""),
      "added-to-cart",
      null
    );
  });




        // Remove logic
        document
          .querySelector(".remove-from-cart")
          ?.addEventListener("click", function (e) {
            e.preventDefault();
            const line = this.dataset.line || 1;
            this.textContent = "removing...";
            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ line: parseInt(line), quantity: 0 }),
            }).then(() => {
              const modal = document.getElementById("added-to-cart");
              if (modal) {
                setTimeout(() => {
                  modal.remove();
                }, 500);
              }
            });
          });

        if (typeof onReady === "function") onReady();
        return;
      }

      // ✅ DEFAULT DRAWER INTERFACE
      const drawer = document.getElementById("customCartDrawer");
      // drawer.style.top = `${offset}px`;
      drawer.classList.remove("hidden");
      document.body.style.overflow = "hidden";

      const recentWrapper = document.querySelector(".item-recent");
      const recentTitle = document.querySelector(".cart-drawer__title");
      const latestContainer = document.querySelector(".unsub-add-cart");

      // Render recent item
      if (latestContainer) {
        let recentItem = null;
        if (window.lastAddedVariantId) {
          recentItem = cart.items.find(
            (item) => item.variant_id == window.lastAddedVariantId
          );
        }

        if (recentItem) {
          const lineIndex = cart.items.findIndex(
            (i) => i.variant_id === recentItem.variant_id
          );
          latestContainer.innerHTML = `
            <div class="cart-drawer__item">
              <div class="unsub-items-card">
                <div class="unsub-item-box">
                  <img src="${recentItem.image}" class="unsub-item-img" alt="${
            recentItem.title
          }" width="100" height="128">
                  <div class="unsab-item-detail">
                    <div>
                      <div class="unsub-item-title">${
                        recentItem.product_title
                      }</div>
                      <span>${recentItem.variant_title}</span>
                    </div>
                    <div class="unsub-price-box">
                      <div class="qty-control" data-line="${lineIndex + 1}">
                        <button class="qty-decrease">−</button>
                        <span class="qty-value">${recentItem.quantity}</span>
                        <button class="qty-increase">+</button>
                      </div>
                      <a href="#" class="remove-from-cart" data-line="${
                        lineIndex + 1
                      }">remove</a>
                    </div>
                  </div>
                </div>
                <div>
                  <span>$${(recentItem.price / 100).toFixed(2)}</span>
                </div>
              </div>
            </div>`;
          recentWrapper.classList.remove("hidden");
          recentTitle.classList.remove("hidden");
        } else {
          latestContainer.innerHTML = "";
          recentWrapper.classList.add("hidden");
          recentTitle.classList.add("hidden");
        }
      }

      // Render all items
      const itemsHTML = cart.items
        .map(
          (item, index) => `
        <div class="cart-drawer__item">
          <div class="unsub-items-card">
            <div class="unsub-item-box">
              <img src="${item.image}" class="unsub-item-img" alt="${
            item.title
          }" width="100" height="128" />
              <div class="unsab-item-detail">
                <div>
                  <div class="unsub-item-title">${item.product_title}</div>
                  <span class="unsub-item-variant">${item.variant_title}</span>
                </div>
                <div class="unsub-price-box">
                  <div class="qty-control" data-line="${index + 1}">
                    <button class="qty-decrease">−</button>
                    <span class="qty-value">${item.quantity}</span>
                    <button class="qty-increase">+</button>
                  </div>
                  <a href="#" class="remove-from-cart" data-line="${
                    index + 1
                  }">remove</a>
                </div>
              </div>
            </div>
            <div>
              <span>$${(item.price / 100).toFixed(2)}</span>
            </div>
          </div>
        </div>
      `
        )
        .join("");

      document.getElementById("cartDrawerItems").innerHTML = itemsHTML;
      document.getElementById("cartSubtotal").textContent = `$${(
        cart.total_price / 100
      ).toFixed(2)}`;

      // Bind cart item interactions
      document.querySelectorAll(".remove-from-cart").forEach((btn) => {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          const itemBox = this.closest(".cart-drawer__item");
          showItemOverlay(itemBox, "Removing...");
          const line = parseInt(this.dataset.line);
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ line, quantity: 0 }),
          }).then(() => openCustomDrawer());
        });
      });

      document.querySelectorAll(".qty-control").forEach((ctrl) => {
        const line = parseInt(ctrl.dataset.line);
        const decreaseBtn = ctrl.querySelector(".qty-decrease");
        const increaseBtn = ctrl.querySelector(".qty-increase");
        const qtyValue = ctrl.querySelector(".qty-value");

        decreaseBtn.addEventListener("click", () => {
          const itemBox = ctrl.closest(".cart-drawer__item");
          const currentQty = parseInt(qtyValue.textContent);
          if (currentQty <= 1) {
            showItemOverlay(itemBox, "Removing...");
            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ line, quantity: 0 }),
            }).then(() => openCustomDrawer());
          } else {
            const newQty = currentQty - 1;
            showItemOverlay(itemBox, "Updating...");
            updateCartQuantity(line, newQty, qtyValue);
          }
        });

        increaseBtn.addEventListener("click", () => {
          const itemBox = ctrl.closest(".cart-drawer__item");
          const newQty = parseInt(qtyValue.textContent) + 1;
          showItemOverlay(itemBox, "Updating...");
          updateCartQuantity(line, newQty, qtyValue);
        });
      });

      if (typeof onReady === "function") {
        onReady();
      }
    });
}

function closeCustomDrawer() {
  document.getElementById("customCartDrawer").classList.add("hidden");
  document.body.style.overflow = "";
}

function updateCartQuantity(line, quantity, qtySpan) {
  const itemBox = qtySpan.closest(".cart-drawer__item");
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ line, quantity }),
  })
    .then(async (res) => {
      if (!res.ok) {
        const error = await res.json();
        showCartError(error?.message || "Error");
        removeItemOverlay(itemBox);
        throw new Error(error?.message || "Failed to update cart");
      }
      openCustomDrawer();
    })
    .catch((err) => {
      console.error("Cart update error:", err.message);
      removeItemOverlay(itemBox);
    });
}

function showCartError(message) {
  let existing = document.querySelector(".cart-error-message");
  if (!existing) {
    existing = document.createElement("div");
    existing.className = "cart-error-message";
    existing.style.cssText = `
      background: #ffe0e0;
      color: #900;
      font-family: Courier New, monospace;
      padding: 8px 12px;
      margin: 10px 16px;
      font-size: 14px;
      border-radius: 4px;
    `;
    document.querySelector("#cartDrawerItems")?.prepend(existing);
  }
  existing.textContent = message;

  setTimeout(() => {
    existing?.remove();
  }, 5000);
}

// --------------------------------------------------------------------
// SINGLE ADD TO CART.
// --------------------------------------------------------------------
// ==============================================================================
// QUICK - ADD TO CART (button-based via data-variant-id)
// ==============================================================================

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    const addToCartBtn = e.target.closest(
      ".phs-add-to-cart-btn[data-variant-id]"
    );

    if (addToCartBtn) {
      e.preventDefault();

      const variantId = addToCartBtn.getAttribute("data-variant-id");
      if (!variantId) {
        console.error("No variant ID found on button.");
        return;
      }

      // Optional: prevent double click
      if (addToCartBtn.disabled) return;

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = "Adding...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          window.lastAddedVariantId = variantId;
          openCustomDrawer(() => {
            addToCartBtn.textContent = "Add to Cart";
            addToCartBtn.disabled = false;
          });
        })
        .catch((err) => {
          console.error("Add to cart failed:", err);
          addToCartBtn.textContent = "Add to Cart";
          addToCartBtn.disabled = false;
        });
    }
  });
});

// ---------------------------------------------------------------------------

// ==============================================================================
// END QUICK - ADD TO CART (phs version).
// ==============================================================================

function toggleScrollClassOnElement() {
  const el = document.querySelector("#cartDrawerItems");
  if (!el) return;

  if (el.scrollHeight > el.clientHeight) {
    el.classList.add("has-scroll");
  } else {
    el.classList.remove("has-scroll");
  }
}

// Run once on load and resize
window.addEventListener("load", toggleScrollClassOnElement);
window.addEventListener("resize", toggleScrollClassOnElement);

// Watch for content changes in #cartDrawerItems
const target = document.querySelector("#cartDrawerItems");
if (target) {
  const observer = new MutationObserver(toggleScrollClassOnElement);
  observer.observe(target, { childList: true, subtree: true });
}

// ======================================================
// two buttons - click with javascript as we cannot have nested a href
// =========================================================================

document.addEventListener("click", function (e) {
  if (e.target.classList.contains("unsub-js-click")) {
    const href = e.target.getAttribute("data-href");
    if (href) {
      window.location.href = href;
    }
  }
});

// ======================================================
// ENDS HERE - two buttons - click with javascript as we cannot have nested a href
// =========================================================================

// ======================================================
// Move to Wishlist
// =========================================================================

// Assuming this script runs after the DOM is loaded
if (!window.SwymCallbacks) window.SwymCallbacks = [];
window.SwymCallbacks.push(initSwymUI);

let swatAddToCart; // Make swat globally accessible within this script's scope

function initSwymUI(swatInstance) {
  swatAddToCart = swatInstance;
  // No need to query for root if not directly manipulating it here
  fetchWishlist2();
}

function fetchWishlist2() {
  swatAddToCart.fetchLists({
    callbackFn: (lists) => {
      if (!lists || !lists.length) {
        console.log("No wishlist lists found, creating a new one...");

        const listConfig = {
          lname: "My Wishlist",
        };

        swatAddToCart.createList(
          listConfig,
          function (newList) {
            // console.log(
            //   "Successfully created a new list:",
            //   newList.lname,
            //   newList.lid
            // );
            swatAddToCart.swymCustomWishlistLists = [newList];
            swatAddToCart.swymCustomWishlistSelectedListId = newList.lid;
          },
          function (error) {
            console.error("Error while creating a new list:", error);
          }
        );

        return; // stop further processing until list is created
      }

      // if lists exist
      lists.reverse();
      swatAddToCart.swymCustomWishlistLists = lists;

      const currentId = swatAddToCart.swymCustomWishlistSelectedListId;
      const selected = lists.find((l) => l.lid === currentId) || lists[0];
      swatAddToCart.swymCustomWishlistSelectedListId = selected.lid;
    },

    errorFn: (err) => {
      console.error("Swym fetchLists error", err);
      console.log("Error fetching wishlist, showing empty state.");
    },
  });
}

function checkProductInWishlist(mainProductId) {
  return new Promise((resolve) => {
    // We assume swat.swymCustomWishlistSelectedListId is already available
    const selectedListId = swatAddToCart.swymCustomWishlistSelectedListId;

    if (!selectedListId) {
      console.warn(
        "swatAddToCart.swymCustomWishlistSelectedListId is not set. Cannot check wishlist."
      );
      resolve(false);
      return;
    }

    const handleListContents = (listContents) => {
      if (!listContents?.length) {
        resolve(false); // No items in the list
        return;
      }
      // Check if any item in the list matches the mainProductId
      const productExists = listContents.some((item) => {
        console.log(item.empi,parseInt(mainProductId, 10))
        // *** IMPORTANT: Verify 'item.empi' is the correct property for your product ID ***
        // It might be item.product_id, item.id, item.variant_id, etc., depending on your Swym data structure.
        return item.empi === parseInt(mainProductId, 10); 
      });
      resolve(productExists);
    };

    const handleError = () => {
      console.error(
        "Error fetching wishlist contents for selected list ID:",
        selectedListId
      );
      resolve(false); // Error occurred, assume product doesn't exist
    };

    // Fetch the contents of the specifically selected list
    swatAddToCart.fetchListCtx({ lid: selectedListId }, handleListContents, handleError);
  });
}

function addClassToClosestAncestor(element, targetClass, classToAdd) {
  // Find the closest ancestor element that has the 'targetClass'
  const closestCartItem = element.closest(`.${targetClass}`);

  // If a matching ancestor is found, add the 'classToAdd' to its class list
  if (closestCartItem) {
    closestCartItem.classList.add(classToAdd);
    console.log(
      `Added class '${classToAdd}' to closest .${targetClass} element.`,
      closestCartItem
    );
  } else {
    console.warn(
      `No ancestor with class '.${targetClass}' found for the given element.`,
      element
    );
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Use event delegation on the document body or a higher-level container
  document.body.addEventListener("click", async function (event) {
    // Added 'async' keyword
    const link = event.target.closest(".js-move-to-wishlist");

    if (link) {
      event.preventDefault();

      addClassToClosestAncestor(link, "cart-item", "merge-item-refreshing");

      const closestCartItem = link.closest(".cart-item");
      let lineIndex;
      if (closestCartItem) {
        lineIndex = closestCartItem.dataset.index;
      } else {
        console.warn(
          `No ancestor with class '.cart-item' found for the given element.`,
          link
        );
        return;
      }

      const variantId = link.dataset.variantId;
      const productId = link.dataset.productId; // This is the main product ID for check
      const productUrl = link.dataset.productUrl;

      if (!swatAddToCart) {
        console.error(
          "Swym SDK (swat) not initialized. Cannot add to wishlist."
        );
        // showNotification(
        //   "Error: Wishlist functionality not available.",
        //   "error"
        // );
        return;
      }

      // --- NEW: Check if product already exists in wishlist ---
      try {
        const productAlreadyExists = await checkProductInWishlist(productId);

  
          // Product does not exist, proceed to add to wishlist
          const lid = swatAddToCart.swymCustomWishlistSelectedListId;

          const product = {
            epi: parseInt(variantId), // Unique variant ID
            empi: parseInt(productId), // Master Product Id - This is used in checkProductInWishlist
            du: productUrl, // Product URL
          };

          const removeFromCart = function(){
             // --- Part B: Remove the item from cart (after successful wishlist addition) ---
            const cartRemoveData = {
              line: parseInt(lineIndex),
              quantity: 0,
            };

            fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(cartRemoveData),
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
              })
              .then((cartData) => {
                console.log("Item successfully removed from cart:", cartData);
                document.dispatchEvent(
                  new CustomEvent("theme:cartchanged", {
                    bubbles: true,
                    cancelable: false,
                  })
                );

                fetch("/cart.js")
                  .then((res) => res.json())
                  .then((cart) => {
                    const totalQty = cart.items.reduce(
                      (sum, item) => sum + item.quantity,
                      0
                    );
                    const counterElement =
                      document.getElementById("unsub-cart-count");
                    if (counterElement)
                      counterElement.innerHTML = `${totalQty}`;
                  });
              })
              .catch((error) => {
                console.error("Error removing item from cart:", error);
                showNotification("Error removing item from cart.", "error");
              });
          }
          const onSuccess = function (addedListItem) {
            console.log(
              `Successfully added the Product to List with lid ${lid}`,
              addedListItem
            );

            removeFromCart();
            // showNotification(
            //   "Product successfully added to wishlist!",
            //   "success"
            // );

           
          };

          const onError = function (error) {
            console.log("Error while adding the Product to the List", error);
            showNotification("Error adding product to wishlist.", "error");
          };

          // Call Swym's addToList function
            if (!productAlreadyExists) {
          swatAddToCart.addToList(lid, product, onSuccess, onError);
            }
        else{
             removeFromCart();
        }
        
      } catch (error) {
        console.error("Error checking product in wishlist:", error);
        showNotification("An error occurred while checking wishlist.", "error");
      }
    }
  });
});
// ======================================================
// ENDS HERE - // Move to Wishlist
// =========================================================================


// ======================================================
// STARTS HERE - Link on the slide. 
// =========================================================================

document.addEventListener('DOMContentLoaded', function() {
    const slideLinks = document.querySelectorAll('.unsub-slide-js-link');
    slideLinks.forEach(function(slideLink) {
        slideLink.addEventListener('click', function(event) {
            // Check if the clicked element (event.target) is the specific button
            if (event.target.classList.contains('unsub-slider-button')) {
                // If it's the button, we do NOT prevent default or stop propagation.
                // We want its native 'href' functionality to work.
                // console.log('Clicked on unsub-slider-button. Allowing default link behavior.');
                return; // Exit this function, letting the button's action proceed
            }

            // If it's not the button, but it's part of a .unsub-slide-js-link
            // that has a data-url, then open the data-url.
            const url = this.getAttribute('data-url');
            if (url) {
                // Prevent the default action of the parent (e.g., if the .unsub-slide-js-link
                // is itself an <a> tag, though it's typically a div)
                event.preventDefault();
                window.location.href = url;
            }
        });
    });
});

// ======================================================
// Injecting css into shop installments on product page. 
// =========================================================================


// Font update of the product 
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    const paymentTerms = document.querySelector("shopify-payment-terms");
    if (paymentTerms && paymentTerms.shadowRoot) {
      const shadowRoot = paymentTerms.shadowRoot;

      // Only inject once
      if (!shadowRoot.querySelector("style[data-custom]")) {
        const style = document.createElement("style");
        style.setAttribute("data-custom", "true");

        style.textContent = `
          /* Installments text */
          #shopify-installments-content,
          #shopify-installments-content .font-bold,
          #shopify-installments-content div {
        
            font-family: Figtree;
            font-weight: 300 !important;
            font-size: 15px !important;
          }

          /* CTA button */
          #shopify-installments-cta {
           font-family: Figtree;
            font-weight: 300 !important;
            font-size: 15px !important;
          }
        `;

        shadowRoot.appendChild(style);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


// ======================================================
// ends here - Injecting css into shop installments on product page. 
// =========================================================================


// // =========================================================================================
// // Remove Gift item is cart goes below threshold
// // =========================================================================================

// async function checkAndRemoveGiftIfBelowThreshold() {
//   if (!window.giftSettings || !window.giftSettings.enable_gift) return;

//   const { threshold, variant_id } = window.giftSettings;

//   try {
//     // --- Fetch current cart ---
//     const response = await fetch('/cart.js');
//     const cart = await response.json();

//     const cartTotal = cart.total_price / 100; // convert cents to dollars
//     const qualified = cartTotal >= threshold;

//     // Find if gift item is in cart
//     const giftItem = cart.items.find(item => item.variant_id == variant_id);

//     if (!qualified && giftItem) {
//       console.log('[DEBUG] Cart below threshold. Removing gift item...');

//       // Remove gift from cart
//       await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           id: giftItem.key,
//           quantity: 0
//         })
//       });

//       console.log('[DEBUG] Gift item removed.');

//        document.dispatchEvent(
//                   new CustomEvent("theme:cartchanged", {
//                     bubbles: true,
//                     cancelable: false,
//                   })
//                 );
//       // Emit a custom event for other scripts/UI updates
//       const event = new CustomEvent('giftItemRemoved', {
//         detail: {
//           message: 'Gift item removed due to cart total below threshold',
//           variantId: variant_id,
//           currentTotal: cartTotal
//         }
//       });
//       window.dispatchEvent(event);
//     }
//   } catch (error) {
//     console.error('[ERROR] Failed to check/remove gift item:', error);
//   }
// }

// Remove item and reduce quantity to 1 if more than 1

async function checkAndRemoveGiftIfBelowThreshold() {
  if (!window.giftSettings || !window.giftSettings.enable_gift) return;

  const { threshold, variant_id } = window.giftSettings;

  try {
    // --- Fetch current cart ---
    const response = await fetch('/cart.js');
    const cart = await response.json();

    const cartTotal = cart.total_price / 100; // convert cents to dollars
    const qualified = cartTotal >= threshold;

    // =========================================================================================
    // Enforce max quantity 1 for this specific variant
    // =========================================================================================
    const restrictedItem = cart.items.find(item => item.variant_id == variant_id);

    if (restrictedItem && restrictedItem.quantity > 1) {
      console.log('[DEBUG] Restricted item exceeds max qty. Reducing to 1...');

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: restrictedItem.key,
          quantity: 1
        })
      });

      document.dispatchEvent(
        new CustomEvent("theme:cartchanged", {
          bubbles: true,
          cancelable: false,
        })
      );
    }

    // ================================
    // Gift removal logic
    // ================================
    const giftItem = restrictedItem;

    if (!qualified && giftItem) {
      console.log('[DEBUG] Cart below threshold. Removing gift item...');

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: giftItem.key,
          quantity: 0
        })
      });

      console.log('[DEBUG] Gift item removed.');

      document.dispatchEvent(
        new CustomEvent("theme:cartchanged", {
          bubbles: true,
          cancelable: false,
        })
      );

      // Emit custom event
      window.dispatchEvent(
        new CustomEvent('giftItemRemoved', {
          detail: {
            message: 'Gift item removed due to cart total below threshold',
            variantId: variant_id,
            currentTotal: cartTotal
          }
        })
      );
    }
  } catch (error) {
    console.error('[ERROR] Failed to check/remove gift item:', error);
  }
}


document.addEventListener('cart:updated', checkAndRemoveGiftIfBelowThreshold);
document.addEventListener('theme:cartchanged', checkAndRemoveGiftIfBelowThreshold);

window.addEventListener('giftItemRemoved', (e) => {
  console.log('Gift removed event detected:', e.detail);
  // Example: refresh gift message or UI
  // document.querySelector('.gift-offer-container')?.remove();
});

// =========================================================================================
// Remove Gift item is cart goes below threshold
// =========================================================================================

// calling on load
checkAndRemoveGiftIfBelowThreshold();


// ------------------------------------
// Delete the Cache daily. 
// ---------------------------------------

// -------------------------------------------------------
// Cache Reset Logic (Daily + Based on Theme Update Time)
// -------------------------------------------------------
(async function () {
  const CACHE_NAME = 'ajax-page-cache-v1';
  const CACHE_RESET_KEY = 'ajaxCacheLastReset';

  // ------------------------------
  // 1. Combine Theme Settings Date + Time (EST)
  // ------------------------------
  const themeDate = window.theme_settings?.last_updated_date;   // "2025-12-02"
  const themeTime = window.theme_settings?.last_updated_time;   // "14:30"
  let themeTimestampEST = null;

  if (themeDate && themeTime) {
    // Convert EST (UTC-5 / UTC-4 depending on DST) to UTC timestamp
    // NOTE: EST = UTC-5 (STANDARD), EDT = UTC-4 (DST)
    // We default to EST (UTC-5) unless you want DST handling.
    const estString = `${themeDate}T${themeTime}:00-05:00`;
    themeTimestampEST = new Date(estString).getTime();
  }

  // ------------------------------
  // 2. Retrieve last cache reset timestamp
  // ------------------------------
  const lastReset = Number(localStorage.getItem(CACHE_RESET_KEY));
  const now = Date.now();
  const ONE_DAY = 24 * 60 * 60 * 1000;

  let shouldReset = false;

  // Reset if first time OR 24 hours passed
  if (!lastReset || now - lastReset > ONE_DAY) {
    console.log('[CacheAPI] 🗑️ Daily cache reset triggered.');
    shouldReset = true;
  }


// debugging
// // Calculate difference (in ms) between theme updated time and cache reset time
// const diffMs = themeTimestampEST - lastReset;

// // Breakdown for debugging
// const diffSec = Math.floor(diffMs / 1000);
// const diffMin = Math.floor(diffSec / 60);
// const diffHr = Math.floor(diffMin / 60);
// const diffDays = Math.floor(diffHr / 24);

// const remainingHr = diffHr % 24;
// const remainingMin = diffMin % 60;
// const remainingSec = diffSec % 60;

// // Timestamps for debugging
// const estDate = new Date(themeTimestampEST);
// const localThemeDate = new Date(themeTimestampEST).toLocaleString();

// const cacheResetLocal = new Date(lastReset).toLocaleString();

// // Current time
// const nowLocal = new Date().toLocaleString();
// const nowEST = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });

// // Debug Header
// console.log(
//   "%c[CacheAPI] 🗑️ Theme timestamp is newer → Resetting cache.",
//   "color: #d32f2f; font-weight: bold;"
// );

// // Print Times
// console.log(` Theme Updated (EST):        ${estDate.toLocaleString("en-US", { timeZone: "America/New_York" })}`);
// console.log(` Theme Updated (Local):      ${localThemeDate}`);
// console.log(` Cache Last Reset (Local):   ${cacheResetLocal}`);

// console.log(` Current Time (Local):       ${nowLocal}`);
// console.log(` Current Time (EST):         ${nowEST}`);

// // Differences
// console.log(` Time Difference (raw ms):   ${diffMs}`);
// console.log(` Time Diff Breakdown:        ${diffDays}d ${remainingHr}h ${remainingMin}m ${remainingSec}s`);

// debuggin ends

  // Reset if theme’s timestamp is newer than cache timestamp
  if (themeTimestampEST && lastReset && themeTimestampEST > lastReset) {
    console.log(
      '[CacheAPI] 🗑️ Theme timestamp is newer → Resetting cache.\n' +
      `Theme updated @ ${new Date(themeTimestampEST).toLocaleString()} EST\n` +
      `Cache last reset @ ${new Date(lastReset).toLocaleString()}`
    );
    shouldReset = true;
  }

  // ------------------------------
  // 3. Execute deletion only once
  // ------------------------------
  if (shouldReset) {
    await caches.delete(CACHE_NAME);
    localStorage.setItem(CACHE_RESET_KEY, now);
    console.log('[CacheAPI] 🔄 Cache cleared & reset timestamp updated.');
  }
})();



// ---------------------------------------


// ---------------------------------------
// Navigation Scroll State

let lastScrollTop = 0;
const threshold = 100;
const delta = 0; // minimum scroll difference
const bottomThreshold = 50; //  configurable bottom threshold

window.addEventListener('scroll', () => {
  const st = window.scrollY;

  const docHeight = document.documentElement.scrollHeight;
  const winHeight = window.innerHeight;
  const distanceFromBottom = docHeight - (st + winHeight);

  //  Do nothing if we're near the bottom
  if (distanceFromBottom <= bottomThreshold) {
    lastScrollTop = st;
    return;
  }

  const tier1Element = document.querySelector('.tier-1');
  const headerRow = document.querySelector('.unsub-header-first-row');
  const siteControlInner = document.querySelector('.site-control__inner');
  const siteControl = document.querySelector('#site-control');

  // 1. SCROLLED STATE (Threshold check)
  if (st > threshold) {
    if (st < lastScrollTop - delta) {
      // Scrolling UP
      tier1Element?.classList.add('scrolled-unsub');
      headerRow?.classList.add('scrolled-unsub');
      siteControlInner?.classList.add('scrolled-unsub');
      siteControl?.classList.remove('hidden');
    } 
    else if (st > lastScrollTop + delta) {
      // Scrolling DOWN
      siteControl?.classList.add('hidden');
    }
  } else {
    // Reset near top
    tier1Element?.classList.remove('scrolled-unsub');
    headerRow?.classList.remove('scrolled-unsub');
    siteControlInner?.classList.remove('scrolled-unsub');
    siteControl?.classList.remove('hidden');
  }

  lastScrollTop = st;
});

// ---------------------------------------
// Navigation Scroll State - ends
// ---------------------------------------
